import { render, staticRenderFns } from "./DragDropDiv.vue?vue&type=template&id=0cb7f27a&scoped=true&"
import script from "./DragDropDiv.vue?vue&type=script&lang=js&"
export * from "./DragDropDiv.vue?vue&type=script&lang=js&"
import style0 from "./DragDropDiv.vue?vue&type=style&index=0&id=0cb7f27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7f27a",
  null
  
)

export default component.exports